/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'common-components/Icon';
import { injectIntl } from 'react-intl';
import { deviceDetect } from 'utils/helpers';

const propTypes = {
  companyColor: PropTypes.string.isRequired,
  anonymousJob: PropTypes.bool.isRequired,
  companyOriginUrl: PropTypes.string,
  intl: PropTypes.shape({
    messages: PropTypes.shape(),
    formatDate: PropTypes.func,
  }).isRequired,
  inscribedInOffer: PropTypes.bool.isRequired,
  job: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    category: PropTypes.string,
    job_locations: PropTypes.arrayOf(PropTypes.shape({
      region: PropTypes.shape({
        name: PropTypes.string,
      }),
    })),
    job_setting: PropTypes.shape({
      hide_job_in_career_sites: PropTypes.bool,
      hide_detail_box: PropTypes.bool,
      hide_location: PropTypes.bool,
      hide_publication_date: PropTypes.bool,
    }),
    subcategory: PropTypes.string,
    department: PropTypes.string,
    activation_date: PropTypes.string,
    order_date: PropTypes.string,
    period_salary: PropTypes.string,
    professional_level: PropTypes.string,
    show_salary: PropTypes.bool,
    salary_description: PropTypes.string,
    status: PropTypes.string,
    sector: PropTypes.string,
    workday: PropTypes.string,
    work_mode: PropTypes.string,
  }).isRequired,
  userLoggedIn: PropTypes.bool.isRequired,
  jobClosed: PropTypes.bool.isRequired,
  openedForm: PropTypes.bool.isRequired,
  openForm: PropTypes.func.isRequired,
  whatsappMessageLink: PropTypes.string.isRequired,
};

const defaultProps = {
  companyOriginUrl: undefined,
};

class Sidebar extends React.Component {
  constructor(props) {
    super(props);

    this.shareByEmail = this.shareByEmail.bind(this);
    this.shareByWhatsapp = this.shareByWhatsapp.bind(this);
    this.copy = this.copy.bind(this);
  }

  copy() {
    const url = window.location.href;
    const tempInput = document.createElement('input');

    tempInput.value = url;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    document.body.click();
  }

  shareByEmail() {
    const { title } = this.props.job;

    const url = `mailto:?Subject=${title}&Body=${window.location.href}`;
    window.open(url);
  }

  shareByWhatsapp() {
    const { whatsappMessageLink } = this.props;
    const url = `${whatsappMessageLink}?text=${window.location.href}`;

    window.open(url);
  }

  render() {
    const {
      job, jobClosed, companyColor,
      companyOriginUrl, inscribedInOffer,
      userLoggedIn, anonymousJob, openForm,
      intl: { messages, formatDate }, openedForm,
      job: { job_setting: jobSetting },
    } = this.props;
    const facebookLink = `https://www.facebook.com/sharer.php?u=${window.location.href}`;
    const linkedinLink = `https://www.linkedin.com/shareArticle?url=${window.location.href}`;
    const twitterLink = `https://twitter.com/share?url=${window.location.href}`;
    const isMobile = deviceDetect();

    const showFormStyle = {
      backgroundColor: companyColor,
      border: `${companyColor} solid 1px`,
    };
    const showJobDetailStyle = {
      color: companyColor,
      border: `${companyColor} solid 1px`,
    };

    const jobInternal = job.status === 'internal';

    return (
      !openedForm &&
        <div className="Sidebar">
          <div className="row-buttons mb-10">
            {
              jobClosed && !inscribedInOffer &&
                <div className="closed-offer">
                  <div className="closed-message">
                    {messages['jobs.closed_offer']}
                  </div>
                  {!anonymousJob && companyOriginUrl &&
                    <button
                      className="button"
                      style={showFormStyle}
                      onClick={() => (window.location.href = companyOriginUrl)}
                    >
                      {messages['jobs.similar_offers']}
                    </button>
                  }
                </div>
            }
            { inscribedInOffer && messages['jobs.inscribed_in_job'] }
            {
              !jobClosed && !inscribedInOffer &&
                <button
                  className="button mb-2"
                  style={openedForm ? showJobDetailStyle : showFormStyle}
                  onClick={openForm}
                >
                  {openedForm ? messages['jobs.job_detail'] : messages['jobs.send_cv']}
                </button>
            }
            {
              !anonymousJob && !jobClosed && !userLoggedIn &&
                <button
                  className="button outline"
                  data-modal-content=""
                  data-target="#login-modal"
                  onClick={event => event.preventDefault()}
                >
                  <span className="log-in">
                    {messages['jobs.log_in']}
                  </span>
                </button>
            }
          </div>
          { !jobSetting.hide_publication_date &&
            <div className="flex mb-4">
              <Icon name="huge-clock-01-stroke-rounded" klass="mr-2 is-grey" />
              <div className="h4 !font-normal">
                <span className="is-grey date">
                  {`${messages['jobs.date']} ${formatDate(new Date(job.activation_date || job.order_date), { year: 'numeric', month: 'long', day: 'numeric' })}`}
                </span>
              </div>
            </div>
          }
          <div className="actions">
            { !job.job_setting.hide_detail_box &&
              <div className="flat-box mb-10">
                {!jobSetting.hide_location && job.job_locations.length &&
                  job.job_locations[0].region !== undefined &&
                  <div className="elements">
                    <Icon name="huge-location-01-stroke-rounded" size="small" />
                    <div className="text">
                      <span className="is-grey">
                        {messages['jobs.location']}
                      </span>
                      <div className="font-bold">
                        {`${job.job_locations[0].region.name}`}
                      </div>
                    </div>
                  </div>
                }
                { job.show_salary &&
                  <div className="elements">
                    <Icon name="huge-coins-01-stroke-rounded" size="small" />
                    <div className="text">
                      <span className="is-grey">{messages['jobs.salary']}</span>
                      <div className="font-bold">{job.salary_description}</div>
                      <div className="font-bold">{messages[`shared.job_data.period_salaries.${job.period_salary}`]}</div>
                    </div>
                  </div>
                }
                <div className="elements">
                  <Icon name="huge-folder-01-stroke-rounded" size="small" />
                  <div className="text">
                    <span className="is-grey">{messages['jobs.category']}</span>
                    <div className="font-bold">{messages[`shared.job_data.categories.${job.category}.__name__`]}</div>
                  </div>
                </div>
                <div className="elements">
                  <Icon name="huge-structure-folder-stroke-rounded" size="small" />
                  <div className="text">
                    <span className="is-grey">{messages['jobs.subcategory']}</span>
                    <div className="font-bold">{messages[`shared.job_data.categories.${job.category}.${job.subcategory}`]}</div>
                  </div>
                </div>
                <div className="elements">
                  <Icon name="huge-grid-view-stroke-rounded" size="small" />
                  <div className="text">
                    <span className="is-grey">{messages['jobs.sector']}</span>
                    <div className="font-bold">{messages[`shared.job_data.sectors.${job.sector}`]}</div>
                  </div>
                </div>
                <div className="elements">
                  <Icon name="huge-clock-01-stroke-rounded" size="small" />
                  <div className="text">
                    <span className="is-grey">{messages['jobs.workday']}</span>
                    <div className="font-bold">{messages[`shared.job_data.workday_types.${job.workday}`]}</div>
                  </div>
                </div>
                <div className="elements">
                  <Icon name="huge-laptop-stroke-rounded" size="small" />
                  <div className="text">
                    <span className="is-grey">{messages['jobs.work_mode']}</span>
                    <div className="font-bold">{messages[`shared.job_data.work_mode.${job.work_mode}`]}</div>
                  </div>
                </div>
                <div className="elements">
                  <Icon name="huge-layers-01-stroke-rounded" size="small" />
                  <div className="text">
                    <span className="is-grey">{messages['jobs.professional_level']}</span>
                    <div className="font-bold">{messages[`shared.job_data.professional_levels.${job.professional_level}`]}</div>
                  </div>
                </div>
                <div className="elements">
                  <Icon name="huge-departement-stroke-rounded" size="small" />
                  <div className="text">
                    <span className="is-grey">{messages['jobs.department']}</span>
                    <div className="font-bold">{messages[`shared.job_data.departments.${job.department}`]}</div>
                  </div>
                </div>
              </div>
            }
            {!jobClosed && !jobInternal &&
              <div className="share">
                <ul className="icons">
                  <li>
                    <a
                      className="twitter"
                      href={twitterLink}
                      rel="noopener noreferrer nofollow"
                      target="_blank"
                    >
                      X
                    </a>
                  </li>
                  <li>
                    <a
                      className="facebook"
                      href={facebookLink}
                      rel="noopener noreferrer nofollow"
                      target="_blank"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      className="linkedin"
                      href={linkedinLink}
                      rel="noopener noreferrer nofollow"
                      target="_blank"
                    >
                      Linkedin
                    </a>
                  </li>
                  {isMobile ?
                    <li>
                      <button className="whatsapp reset" onClick={this.shareByWhatsapp} />
                    </li>
                    :
                    <li>
                      <button className="email reset" onClick={this.shareByEmail} />
                    </li>
                  }
                  <li>
                    <button className="ico-link" onClick={this.copy} />
                  </li>
                </ul>
              </div>
            }
          </div>
        </div>
    );
  }
}

Sidebar.propTypes = propTypes;
Sidebar.defaultProps = defaultProps;

export default injectIntl(Sidebar);
